/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { DistrictResource } from '../model/models';
import { GetDistrictsFilterParameter } from '../model/models';
import { InlineObject } from '../model/models';
import { InlineObject1 } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface DistrictServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * List of districts
     * 
     * @param perPage 
     * @param page 
     * @param filter 
     */
    getDistricts(perPage?: number, page?: number, filter?: GetDistrictsFilterParameter, extraHttpRequestParams?: any): Observable<Array<DistrictResource>>;

}
